// import React, { useState, useEffect } from "react";
// import {
//     Search,
//     FileText,
//     CheckCircle2,
//     Package,
//     Truck,
//     Clock,
//     X,
//     Calendar,
//     IndianRupee,
//     Building2,
//     RefreshCw,
//     User,
//     AlertCircle,
//     Check,
//     XCircle,
//     Loader2,
//     Eye,
//     CheckCheck,
//     PackageCheck,
//     ShieldCheck,
//     Truck as TruckIcon,
//     ChevronDown,
// } from "lucide-react";
// import { bookingService } from "../service/Vendorservisefile/bookingService.jsx";

// // ---- Custom scrollbar styling ------------------------------------------------
// function ScrollbarStyles() {
//     return (
//         <style>{`
//             .custom-scrollbar::-webkit-scrollbar {
//                 width: 6px;
//                 height: 6px;
//             }
//             .custom-scrollbar::-webkit-scrollbar-track {
//                 background: transparent;
//             }
//             .custom-scrollbar::-webkit-scrollbar-thumb {
//                 background-color: #CBD5E1;
//                 border-radius: 9999px;
//                 border: 2px solid transparent;
//                 background-clip: padding-box;
//             }
//             .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//                 background-color: #94A3B8;
//             }
//             .custom-scrollbar {
//                 scrollbar-width: thin;
//                 scrollbar-color: #CBD5E1 transparent;
//             }
//             @media (max-width: 640px) {
//                 .mobile-table {
//                     display: block;
//                 }
//                 .mobile-table thead {
//                     display: none;
//                 }
//                 .mobile-table tbody {
//                     display: block;
//                 }
//                 .mobile-table tbody tr {
//                     display: block;
//                     padding: 16px;
//                     margin-bottom: 12px;
//                     border: 1px solid #E2E8F0;
//                     border-radius: 12px;
//                     background: white;
//                 }
//                 .mobile-table tbody td {
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     padding: 6px 0;
//                     border: none;
//                 }
//                 .mobile-table tbody td::before {
//                     content: attr(data-label);
//                     font-weight: 600;
//                     color: #64748B;
//                     font-size: 11px;
//                     text-transform: uppercase;
//                 }
//                 .mobile-table tbody td:last-child {
//                     border-bottom: none;
//                 }
//                 .mobile-table tbody td .mobile-label {
//                     display: inline;
//                 }
//             }
//         `}</style>
//     );
// }

// const currency = (n) => "\u20B9" + n.toLocaleString("en-IN");

// const formatDate = (d) => {
//     if (!d) return "-";
//     const date = new Date(d);
//     return date.toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//     });
// };

// const formatTime = (time) => {
//     if (!time) return "-";
//     if (time.includes(':')) {
//         const [hours, minutes] = time.split(':');
//         const h = parseInt(hours);
//         const ampm = h >= 12 ? 'PM' : 'AM';
//         const h12 = h % 12 || 12;
//         return `${h12}:${minutes} ${ampm}`;
//     }
//     return time;
// };

// // ---- Status configuration with flow -------------------------------------------
// const STATUS_FLOW = {
//     CREATED: {
//         label: "Created",
//         order: 1,
//         icon: Clock,
//         color: "#F59E0B",
//         bg: "#FEF3C7",
//         text: "#B45309",
//         nextActions: ["ACCEPTED", "CANCELLED"]
//     },
//     ACCEPTED: {
//         label: "Accepted",
//         order: 2,
//         icon: CheckCircle2,
//         color: "#6366F1",
//         bg: "#EEF0FF",
//         text: "#4338CA",
//         nextActions: ["IN_PROGRESS", "CANCELLED"]
//     },
//     IN_PROGRESS: {
//         label: "In Progress",
//         order: 3,
//         icon: Truck,
//         color: "#0EA5E9",
//         bg: "#E9F7FE",
//         text: "#0369A1",
//         nextActions: ["QUALITY_CHECK", "CANCELLED"]
//     },
//     QUALITY_CHECK: {
//         label: "Quality Check",
//         order: 4,
//         icon: ShieldCheck,
//         color: "#8B5CF6",
//         bg: "#F3EEFE",
//         text: "#6D28D9",
//         nextActions: ["READY_FOR_DELIVERY", "CANCELLED"]
//     },
//     READY_FOR_DELIVERY: {
//         label: "Ready for Delivery",
//         order: 5,
//         icon: PackageCheck,
//         color: "#F59E0B",
//         bg: "#FEF3C7",
//         text: "#B45309",
//         nextActions: ["DELIVERED", "CANCELLED"]
//     },
//     DELIVERED: {
//         label: "Delivered",
//         order: 6,
//         icon: TruckIcon,
//         color: "#22C55E",
//         bg: "#D1FAE5",
//         text: "#065F46",
//         nextActions: ["COMPLETED"]
//     },
//     COMPLETED: {
//         label: "Completed",
//         order: 7,
//         icon: CheckCheck,
//         color: "#22C55E",
//         bg: "#D1FAE5",
//         text: "#065F46",
//         nextActions: []
//     },
//     CANCELLED: {
//         label: "Cancelled",
//         order: 8,
//         icon: XCircle,
//         color: "#EF4444",
//         bg: "#FEE2E2",
//         text: "#991B1B",
//         nextActions: []
//     },
// };

// // Get status by key with fallback
// const getStatusConfig = (status) => {
//     return STATUS_FLOW[status] || {
//         label: status || "Unknown",
//         order: 99,
//         icon: Clock,
//         color: "#94A3B8",
//         bg: "#F1F5F9",
//         text: "#475569",
//         nextActions: []
//     };
// };

// // ---- Stat card ---------------------------------------------------------------
// function StatCard({ label, value, icon: Icon, accent, onClick, active }) {
//     return (
//         <div
//             onClick={onClick}
//             className={`rounded-2xl border ${active ? 'border-indigo-500 ring-2 ring-indigo-200' : 'border-slate-200'} bg-white px-4 py-4 sm:px-6 sm:py-5 flex flex-col gap-2 sm:gap-3 cursor-pointer transition-all hover:shadow-md`}
//         >
//             <div className="flex items-center justify-between">
//                 <span className="text-[10px] sm:text-[11px] font-semibold tracking-wider text-slate-400 uppercase">
//                     {label}
//                 </span>
//                 <div
//                     className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center flex-shrink-0"
//                     style={{ backgroundColor: accent + "15" }}
//                 >
//                    <Icon size={14} style={{ color: accent }} />
//                 </div>
//             </div>
//             <span className="text-xl sm:text-2xl font-bold text-slate-900">{value}</span>
//         </div>
//     );
// }

// // ---- Status Dropdown Component -----------------------------------------------
// function StatusDropdown({ currentStatus, bookingId, onStatusUpdate }) {
//     const [isOpen, setIsOpen] = useState(false);
//     const [updating, setUpdating] = useState(false);
//     const [selectedStatus, setSelectedStatus] = useState(currentStatus);

//     const config = getStatusConfig(currentStatus);
//     const StatusIcon = config.icon;

//     // Get all available statuses
//     const allStatuses = ["CREATED", "ACCEPTED", "IN_PROGRESS", "QUALITY_CHECK", "READY_FOR_DELIVERY", "DELIVERED", "COMPLETED", "CANCELLED"];
    
//     // Filter statuses that are allowed from current status
//     const availableStatuses = allStatuses.filter(status => {
//         if (status === currentStatus) return true;
//         return config.nextActions.includes(status);
//     });

//     const handleStatusChange = async (status) => {
//         if (status === currentStatus) {
//             setIsOpen(false);
//             return;
//         }

//         setUpdating(true);
//         try {
//             await bookingService.updateWorkOrderStatus(bookingId, status);
//             setSelectedStatus(status);
//             if (onStatusUpdate) {
//                 onStatusUpdate(bookingId, status);
//             }
//             setIsOpen(false);
//         } catch (error) {
//             console.error("Error updating status:", error);
//             alert("Failed to update status. Please try again.");
//         } finally {
//             setUpdating(false);
//         }
//     };

//     return (
//         <div className="relative inline-block">
//             <button
//                 onClick={() => setIsOpen(!isOpen)}
//                 disabled={updating}
//                 className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium transition-all hover:shadow-md"
//                 style={{ 
//                     backgroundColor: config.bg, 
//                     color: config.text,
//                     opacity: updating ? 0.6 : 1
//                 }}
//             >
//                 {updating ? (
//                     <Loader2 size={12} className="animate-spin" />
//                 ) : (
//                     <StatusIcon size={12} />
//                 )}
//                 <span>{updating ? "Updating..." : config.label}</span>
//                 <ChevronDown size={12} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
//             </button>

//             {isOpen && (
//                 <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-slate-200 py-1 z-50 min-w-[160px]">
//                     {availableStatuses.map((status) => {
//                         const statusConfig = getStatusConfig(status);
//                         const StatusIconComp = statusConfig.icon;
//                         const isActive = status === currentStatus;
                        
//                         return (
//                             <button
//                                 key={status}
//                                 onClick={() => handleStatusChange(status)}
//                                 disabled={updating || isActive}
//                                 className={`w-full px-4 py-2 text-left text-xs font-medium transition-colors flex items-center gap-2 hover:bg-slate-50 ${
//                                     isActive ? 'bg-slate-100 cursor-default' : ''
//                                 }`}
//                                 style={{ 
//                                     color: isActive ? statusConfig.text : '#475569'
//                                 }}
//                             >
//                                 <StatusIconComp size={12} style={{ color: statusConfig.color }} />
//                                 <span>{statusConfig.label}</span>
//                                 {isActive && (
//                                     <Check size={12} className="ml-auto text-emerald-500" />
//                                 )}
//                             </button>
//                         );
//                     })}
//                 </div>
//             )}
//         </div>
//     );
// }

// // ---- Booking Details Modal (View Only) ---------------------------------------
// function BookingDetailsModal({ booking, onClose }) {
//     if (!booking) return null;

//     const currentConfig = getStatusConfig(booking.bookingStatus);
//     const StatusIcon = currentConfig.icon || Clock;

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
//             <div
//                 className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px]"
//                 onClick={onClose}
//             />
//             <div className="relative w-full max-w-lg rounded-2xl bg-white shadow-xl border border-slate-200 overflow-hidden max-h-[95vh] flex flex-col">
//                 <div className="flex items-start justify-between px-4 sm:px-6 pt-4 sm:pt-6 pb-3 sm:pb-4 border-b border-slate-100 flex-shrink-0">
//                     <div className="min-w-0">
//                         <h2 className="text-base sm:text-lg font-bold text-slate-900 truncate">Order Details</h2>
//                         <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
//                             Order #{booking.bookingId}
//                         </p>
//                     </div>
//                     <button
//                         onClick={onClose}
//                         className="text-slate-400 hover:text-slate-600 rounded-lg p-1 flex-shrink-0"
//                     >
//                         <X size={18} />
//                     </button>
//                 </div>

//                 <div className="px-4 sm:px-6 py-4 sm:py-5 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
//                     {/* Status Timeline */}
//                     <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
//                         <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">Order Progress</h3>
//                         <StatusTimeline currentStatus={booking.bookingStatus} />
//                     </div>

//                     <div className="rounded-xl bg-slate-50 border border-slate-100 p-3 sm:p-4 space-y-2 sm:space-y-3">
//                         <div className="flex items-center justify-between text-xs sm:text-sm">
//                             <span className="text-slate-500 flex items-center gap-1.5">
//                                 <User size={14} /> Customer
//                             </span>
//                             <span className="font-medium text-slate-800 text-right truncate ml-2">{booking.userName}</span>
//                         </div>
//                         <div className="flex items-center justify-between text-xs sm:text-sm">
//                             <span className="text-slate-500 flex items-center gap-1.5">
//                                 <Building2 size={14} /> Facility
//                             </span>
//                             <span className="font-medium text-slate-800 text-right truncate ml-2">{booking.facilityName}</span>
//                         </div>
//                         <div className="flex items-center justify-between text-xs sm:text-sm">
//                             <span className="text-slate-500 flex items-center gap-1.5">
//                                 <Package size={14} /> Machine
//                             </span>
//                             <span className="font-medium text-slate-800 text-right truncate ml-2">{booking.machineName}</span>
//                         </div>
//                         <div className="flex items-center justify-between text-xs sm:text-sm">
//                             <span className="text-slate-500 flex items-center gap-1.5">
//                                 <Calendar size={14} /> Date
//                             </span>
//                             <span className="font-medium text-slate-800">{formatDate(booking.bookingDate)}</span>
//                         </div>
//                         <div className="flex items-center justify-between text-xs sm:text-sm">
//                             <span className="text-slate-500 flex items-center gap-1.5">
//                                 <Clock size={14} /> Time
//                             </span>
//                             <span className="font-medium text-slate-800 text-right">
//                                 {formatTime(booking.startTime)} - {formatTime(booking.endTime?.split('T')[1] || booking.endTime)}
//                             </span>
//                         </div>
//                         <div className="flex items-center justify-between text-xs sm:text-sm">
//                             <span className="text-slate-500 flex items-center gap-1.5">
//                                 <Clock size={14} /> Duration
//                             </span>
//                             <span className="font-medium text-slate-800">{booking.durationHours} hours</span>
//                         </div>
//                         <div className="flex items-center justify-between text-xs sm:text-sm">
//                             <span className="text-slate-500 flex items-center gap-1.5">
//                                 <IndianRupee size={14} /> Total Amount
//                             </span>
//                             <span className="font-semibold text-slate-900">
//                                 {currency(booking.totalAmount)}
//                             </span>
//                         </div>
//                     </div>

//                     <div>
//                         <div className="text-xs sm:text-sm font-medium text-slate-700 block mb-1.5">Purpose</div>
//                         <div className="rounded-xl border border-slate-100 px-3 py-2 sm:px-3.5 sm:py-2.5 text-xs sm:text-sm text-slate-600 bg-slate-50 break-words">
//                             {booking.purpose || "No purpose specified"}
//                         </div>
//                     </div>

//                     {/* Current Status Display */}
//                     <div>
//                         <div className="text-xs sm:text-sm font-medium text-slate-700 block mb-1.5">Current Status</div>
//                         <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium"
//                             style={{
//                                 backgroundColor: currentConfig.bg,
//                                 color: currentConfig.text
//                             }}
//                         >
//                             <StatusIcon size={16} />
//                             {currentConfig.label}
//                         </div>
//                     </div>
//                 </div>

//                 <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-slate-100 flex items-center justify-end bg-slate-50 flex-shrink-0">
//                     <button
//                         onClick={onClose}
//                         className="px-4 py-2 rounded-xl text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
//                     >
//                         Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

// // ---- Status Timeline Component -----------------------------------------------
// function StatusTimeline({ currentStatus }) {
//     const statuses = ["CREATED", "ACCEPTED", "IN_PROGRESS", "QUALITY_CHECK", "READY_FOR_DELIVERY", "DELIVERED", "COMPLETED"];
//     const currentIndex = statuses.indexOf(currentStatus);
//     const isCancelled = currentStatus === "CANCELLED";

//     if (isCancelled) {
//         return (
//             <div className="flex items-center gap-2 p-3 bg-red-50 rounded-xl border border-red-200">
//                 <XCircle size={20} className="text-red-500 flex-shrink-0" />
//                 <span className="text-sm font-medium text-red-700">Order has been cancelled</span>
//             </div>
//         );
//     }

//     return (
//         <div className="relative">
//             <div className="flex flex-wrap items-center gap-1 sm:gap-2">
//                 {statuses.map((status, index) => {
//                     const config = getStatusConfig(status);
//                     const isCompleted = index <= currentIndex;
//                     const isCurrent = index === currentIndex;
//                     const StatusIcon = config.icon;

//                     return (
//                         <React.Fragment key={status}>
//                             <div className="flex items-center gap-1 sm:gap-2">
//                                 <div
//                                     className={`flex items-center gap-1 sm:gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-[10px] sm:text-xs font-medium transition-all ${
//                                         isCompleted
//                                             ? 'bg-emerald-100 text-emerald-700'
//                                             : 'bg-slate-100 text-slate-400'
//                                     } ${isCurrent ? 'ring-2 ring-emerald-400 shadow-sm' : ''}`}
//                                 >
//                                     <StatusIcon
//                                         size={12}
//                                         className={isCompleted ? 'text-emerald-600' : 'text-slate-400'}
//                                     />
//                                     <span className="whitespace-nowrap">{config.label}</span>
//                                     {isCurrent && (
//                                         <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse ml-0.5" />
//                                     )}
//                                 </div>
//                                 {index < statuses.length - 1 && (
//                                     <div className={`w-4 sm:w-6 h-0.5 ${index < currentIndex ? 'bg-emerald-400' : 'bg-slate-200'}`} />
//                                 )}
//                             </div>
//                         </React.Fragment>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// }

// // ---- Mobile Order Card --------------------------------------------------------
// function MobileOrderCard({ booking, onViewDetails, onStatusUpdate }) {
//     const cfg = getStatusConfig(booking.bookingStatus);
//     const StatusIcon = cfg.icon;

//     return (
//         <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm">
//             <div className="flex items-start justify-between mb-3">
//                 <div>
//                     <div className="font-semibold text-slate-900">#{booking.bookingId}</div>
//                     <div className="text-xs text-slate-400">{booking.bookingType || "WORK_ORDER"}</div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <span
//                         className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-medium"
//                         style={{ backgroundColor: cfg.bg, color: cfg.text }}
//                     >
//                         <StatusIcon size={10} />
//                         {cfg.label}
//                     </span>
//                 </div>
//             </div>
            
//             <div className="space-y-2 text-sm">
//                 <div className="flex items-start gap-2">
//                     <User size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
//                     <span className="text-slate-700">{booking.userName}</span>
//                 </div>
//                 <div className="flex items-start gap-2">
//                     <Package size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
//                     <span className="text-slate-700">{booking.machineName}</span>
//                 </div>
//                 <div className="flex items-start gap-2">
//                     <Building2 size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
//                     <span className="text-slate-700 text-xs">{booking.facilityName}</span>
//                 </div>
//                 <div className="flex items-start gap-2">
//                     <IndianRupee size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
//                     <span className="font-semibold text-slate-900">{currency(booking.totalAmount)}</span>
//                 </div>
//                 <div className="flex items-start gap-2">
//                     <Calendar size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
//                     <span className="text-slate-700">{formatDate(booking.bookingDate)}</span>
//                 </div>
//             </div>

//             <div className="flex items-center gap-2 mt-3">
//                 {/* Status Dropdown */}
//                 <div className="flex-1">
//                     <StatusDropdown 
//                         currentStatus={booking.bookingStatus}
//                         bookingId={booking.bookingId}
//                         onStatusUpdate={onStatusUpdate}
//                     />
//                 </div>
                
//                 <button
//                     onClick={() => onViewDetails(booking)}
//                     className="px-3 py-2 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 rounded-xl text-sm font-medium flex items-center gap-1.5 transition-colors"
//                 >
//                     <Eye size={14} /> View
//                 </button>
//             </div>
//         </div>
//     );
// }

// // ---- Main page ----------------------------------------------------------------
// export default function OrdersPage() {
//     const [bookings, setBookings] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [query, setQuery] = useState("");
//     const [selectedBooking, setSelectedBooking] = useState(null);
//     const [toast, setToast] = useState(null);
//     const [activeFilter, setActiveFilter] = useState("all");
//     const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth < 640);
//         };
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     useEffect(() => {
//         // Try to load from cache first
//         const cached = bookingService.getCachedBookings();
//         if (cached && cached.length > 0) {
//             setBookings(cached);
//             setLoading(false);
//         }
//         fetchBookings();
//     }, []);

//     const fetchBookings = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             const data = await bookingService.getVendorBookings();
//             setBookings(data || []);
//             if (data && data.length === 0) {
//                 setToast("No bookings found");
//                 setTimeout(() => setToast(null), 3000);
//             }
//         } catch (err) {
//             console.error("Error fetching bookings:", err);
//             // If API fails, try to use cached data
//             const cached = bookingService.getCachedBookings();
//             if (cached && cached.length > 0) {
//                 setBookings(cached);
//                 setError("Using cached data. Please refresh to get latest updates.");
//             } else {
//                 setError("Failed to load bookings. Please try again.");
//                 setToast("Failed to load bookings");
//                 setTimeout(() => setToast(null), 3000);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleStatusUpdate = (bookingId, newStatus) => {
//         setBookings(prev =>
//             prev.map(b =>
//                 b.bookingId === bookingId
//                     ? { ...b, bookingStatus: newStatus }
//                     : b
//             )
//         );
//         setToast(`Order #${bookingId} status updated to ${getStatusConfig(newStatus).label}`);
//         setTimeout(() => setToast(null), 3000);
//     };

//     const matchesQuery = (b) => {
//         const q = query.toLowerCase();
//         return (
//             b.machineName?.toLowerCase().includes(q) ||
//             b.facilityName?.toLowerCase().includes(q) ||
//             b.userName?.toLowerCase().includes(q) ||
//             b.bookingId?.toString().includes(q)
//         );
//     };

//     const getFilteredBookings = () => {
//         let filtered = bookings.filter(matchesQuery);
//         if (activeFilter !== "all") {
//             filtered = filtered.filter(b => b.bookingStatus === activeFilter.toUpperCase());
//         }
//         return filtered;
//     };

//     const filteredBookings = getFilteredBookings();

//     const counts = {
//         total: bookings.length,
//         created: bookings.filter((b) => b.bookingStatus === "CREATED").length,
//         accepted: bookings.filter((b) => b.bookingStatus === "ACCEPTED").length,
//         in_progress: bookings.filter((b) => b.bookingStatus === "IN_PROGRESS").length,
//         quality_check: bookings.filter((b) => b.bookingStatus === "QUALITY_CHECK").length,
//         ready_for_delivery: bookings.filter((b) => b.bookingStatus === "READY_FOR_DELIVERY").length,
//         delivered: bookings.filter((b) => b.bookingStatus === "DELIVERED").length,
//         completed: bookings.filter((b) => b.bookingStatus === "COMPLETED").length,
//         cancelled: bookings.filter((b) => b.bookingStatus === "CANCELLED").length,
//     };

//     if (loading) {
//         return (
//             <div className="flex items-center justify-center h-screen">
//                 <div className="text-center">
//                     <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
//                     <p className="mt-4 text-slate-600">Loading orders...</p>
//                 </div>
//             </div>
//         );
//     }

//     if (error && !bookings.length) {
//         return (
//             <div className="flex items-center justify-center h-screen px-4">
//                 <div className="text-center">
//                     <p className="text-red-600 mb-4">{error}</p>
//                     <button
//                         onClick={fetchBookings}
//                         className="px-4 py-2 bg-indigo-600 text-white rounded-xl text-sm font-medium hover:bg-indigo-700"
//                     >
//                         Retry
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="min-h-screen bg-slate-50 py-4 sm:py-8 px-3 sm:px-6 font-sans overflow-y-auto custom-scrollbar">
//             <ScrollbarStyles />
//             <div className="max-w-7xl mx-auto space-y-4 sm:space-y-6">
//                 {/* Header */}
//                 <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
//                     <div>
//                         <h1 className="text-lg sm:text-xl font-bold text-slate-900">Work Orders</h1>
//                         <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
//                             Manage all work orders from customers
//                         </p>
//                     </div>
//                     <button
//                         onClick={fetchBookings}
//                         className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs sm:text-sm font-medium transition-colors hover:shadow-lg w-full sm:w-auto justify-center"
//                     >
//                         <RefreshCw size={14} /> Refresh
//                     </button>
//                 </div>

//                 {/* Stat cards */}
//                 <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-4">
    
//     <StatCard
//         label="Created"
//         value={counts.created}
//         icon={Clock}
//         accent="#F59E0B"
//         onClick={() => setActiveFilter("created")}
//         active={activeFilter === "created"}
//     />
//     <StatCard
//         label="Accepted"
//         value={counts.accepted}
//         icon={CheckCircle2}
//         accent="#6366F1"
//         onClick={() => setActiveFilter("accepted")}
//         active={activeFilter === "accepted"}
//     />
//     <StatCard
//         label="In Progress"
//         value={counts.in_progress + counts.quality_check}
//         icon={Truck}
//         accent="#0EA5E9"
//         onClick={() => setActiveFilter("in_progress")}
//         active={activeFilter === "in_progress" || activeFilter === "quality_check"}
//     />
//     <StatCard
//         label="Completed"
//         value={counts.completed + counts.delivered}
//         icon={CheckCircle2}
//         accent="#22C55E"
//         onClick={() => setActiveFilter("completed")}
//         active={activeFilter === "completed" || activeFilter === "delivered"}
//     />
//     <StatCard
//         label="Cancelled"
//         value={counts.cancelled}
//         icon={XCircle}
//         accent="#EF4444"
//         onClick={() => setActiveFilter("cancelled")}
//         active={activeFilter === "cancelled"}
//     />
// </div>

//                 {/* Search and Filters */}
//                 <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-stretch sm:items-center justify-between">
//                     <div className="relative flex-1 max-w-full sm:max-w-md">
//                         <Search
//                             size={16}
//                             className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-slate-400"
//                         />
//                         <input
//                             value={query}
//                             onChange={(e) => setQuery(e.target.value)}
//                             placeholder="Search by machine, facility, user..."
//                             className="w-full rounded-full border border-slate-200 bg-white pl-9 sm:pl-10 pr-4 py-2 text-xs sm:text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
//                         />
//                     </div>

//                     {/* Mobile Filter Dropdown */}
//                     <div className="sm:hidden flex gap-2">
//                         <select
//                             value={activeFilter}
//                             onChange={(e) => setActiveFilter(e.target.value)}
//                             className="flex-1 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-200"
//                         >
//                             <option value="all">All ({counts.total})</option>
//                             <option value="created">Created ({counts.created})</option>
//                             <option value="accepted">Accepted ({counts.accepted})</option>
//                             <option value="in_progress">In Progress ({counts.in_progress + counts.quality_check})</option>
//                             <option value="completed">Completed ({counts.completed + counts.delivered})</option>
//                             <option value="cancelled">Cancelled ({counts.cancelled})</option>
//                         </select>
//                     </div>

//                     {/* Desktop Filter Tabs */}
//                     <div className="hidden sm:inline-flex items-center gap-1 rounded-full bg-slate-100 p-1 flex-wrap">
//                         <button
//                             onClick={() => setActiveFilter("all")}
//                             className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "all"
//                                     ? "bg-white text-indigo-700 shadow-sm"
//                                     : "text-slate-500 hover:text-slate-700"
//                                 }`}
//                         >
//                             All ({counts.total})
//                         </button>
//                         <button
//                             onClick={() => setActiveFilter("created")}
//                             className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "created"
//                                     ? "bg-white text-indigo-700 shadow-sm"
//                                     : "text-slate-500 hover:text-slate-700"
//                                 }`}
//                         >
//                             Created ({counts.created})
//                         </button>
//                         <button
//                             onClick={() => setActiveFilter("accepted")}
//                             className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "accepted"
//                                     ? "bg-white text-indigo-700 shadow-sm"
//                                     : "text-slate-500 hover:text-slate-700"
//                                 }`}
//                         >
//                             Accepted ({counts.accepted})
//                         </button>
//                         <button
//                             onClick={() => setActiveFilter("in_progress")}
//                             className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "in_progress" || activeFilter === "quality_check"
//                                     ? "bg-white text-indigo-700 shadow-sm"
//                                     : "text-slate-500 hover:text-slate-700"
//                                 }`}
//                         >
//                             In Progress ({counts.in_progress + counts.quality_check})
//                         </button>
//                         <button
//                             onClick={() => setActiveFilter("completed")}
//                             className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "completed" || activeFilter === "delivered"
//                                     ? "bg-white text-indigo-700 shadow-sm"
//                                     : "text-slate-500 hover:text-slate-700"
//                                 }`}
//                         >
//                             Completed ({counts.completed + counts.delivered})
//                         </button>
//                     </div>
//                 </div>

//                 {/* Bookings table / cards */}
//                 <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm">
//                     <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-slate-100">
//                         <h2 className="font-bold text-slate-900 text-sm sm:text-[15px]">
//                             {activeFilter === "all" ? "All Work Orders" : `${activeFilter.replace('_', ' ').toUpperCase()} Orders`}
//                         </h2>
//                         <p className="text-xs text-slate-400 mt-0.5">
//                             {activeFilter === "all"
//                                 ? "View all work orders and their status"
//                                 : `View all ${activeFilter.replace('_', ' ')} orders`}
//                         </p>
//                     </div>

//                     {/* Mobile View - Cards */}
//                     {isMobile ? (
//                         <div className="p-3 space-y-3">
//                             {filteredBookings.map((b) => (
//                                 <MobileOrderCard
//                                     key={b.bookingId}
//                                     booking={b}
//                                     onViewDetails={setSelectedBooking}
//                                     onStatusUpdate={handleStatusUpdate}
//                                 />
//                             ))}
//                             {filteredBookings.length === 0 && (
//                                 <div className="text-center text-slate-400 text-sm py-8">
//                                     {query ? "No orders match your search." : "No orders found."}
//                                 </div>
//                             )}
//                         </div>
//                     ) : (
//                         /* Desktop View - Table */
//                         <div className="overflow-auto max-h-[480px] custom-scrollbar">
//                             <table className="w-full text-sm">
//                                 <thead className="sticky top-0 z-10 bg-white">
//                                     <tr className="text-left text-[11px] font-semibold tracking-wider text-slate-400 uppercase border-b border-slate-100">
//                                         <th className="px-6 py-3 font-semibold">Order</th>
//                                         <th className="px-4 py-3 font-semibold">Customer</th>
//                                         <th className="px-4 py-3 font-semibold">Machine / Facility</th>
//                                         <th className="px-4 py-3 font-semibold">Date & Time</th>
//                                         <th className="px-4 py-3 font-semibold text-right">Amount</th>
//                                         <th className="px-4 py-3 font-semibold">Status</th>
//                                         <th className="px-6 py-3 font-semibold text-right">Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {filteredBookings.map((b) => {
//                                         const cfg = getStatusConfig(b.bookingStatus);
//                                         const StatusIcon = cfg.icon;
//                                         return (
//                                             <tr
//                                                 key={b.bookingId}
//                                                 className="border-b border-slate-50 last:border-0 hover:bg-slate-50/60 transition-colors"
//                                             >
//                                                 <td className="px-6 py-4">
//                                                     <div className="font-semibold text-slate-900">
//                                                         #{b.bookingId}
//                                                     </div>
//                                                     <div className="text-xs text-slate-400 mt-0.5">
//                                                         {b.bookingType || "WORK_ORDER"}
//                                                     </div>
//                                                 </td>
//                                                 <td className="px-4 py-4">
//                                                     <div className="font-medium text-slate-700">{b.userName}</div>
//                                                     <div className="text-xs text-slate-400 mt-0.5">
//                                                         User #{b.userId}
//                                                     </div>
//                                                 </td>
//                                                 <td className="px-4 py-4">
//                                                     <div className="font-medium text-slate-700">{b.machineName}</div>
//                                                     <div className="text-xs text-slate-400 mt-0.5 flex items-center gap-1">
//                                                         <Building2 size={11} />
//                                                         {b.facilityName}
//                                                     </div>
//                                                 </td>
//                                                 <td className="px-4 py-4">
//                                                     <div className="text-slate-700">{formatDate(b.bookingDate)}</div>
//                                                     <div className="text-xs text-slate-400 mt-0.5">
//                                                         {formatTime(b.startTime)} - {formatTime(b.endTime?.split('T')[1] || b.endTime)}
//                                                     </div>
//                                                 </td>
//                                                 <td className="px-4 py-4 text-right">
//                                                     <div className="font-semibold text-slate-900">
//                                                         {currency(b.totalAmount)}
//                                                     </div>
//                                                     <div className="text-xs text-slate-400 mt-0.5">
//                                                         {b.durationHours} hrs @ {currency(b.hourlyRate)}/hr
//                                                     </div>
//                                                 </td>
//                                                 <td className="px-4 py-4">
//                                                     <StatusDropdown 
//                                                         currentStatus={b.bookingStatus}
//                                                         bookingId={b.bookingId}
//                                                         onStatusUpdate={handleStatusUpdate}
//                                                     />
//                                                 </td>
//                                                 <td className="px-6 py-4 text-right">
//                                                     <button
//                                                         onClick={() => setSelectedBooking(b)}
//                                                         className="inline-flex items-center gap-1.5 text-indigo-600 hover:text-indigo-800 text-sm font-medium px-3 py-2 rounded-xl border border-indigo-100 hover:bg-indigo-50 transition-colors"
//                                                     >
//                                                         <Eye size={14} /> View Details
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         );
//                                     })}
//                                     {filteredBookings.length === 0 && (
//                                         <tr>
//                                             <td colSpan={7} className="px-6 py-10 text-center text-slate-400 text-sm">
//                                                 {query ? "No orders match your search." : "No orders found."}
//                                             </td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {selectedBooking && (
//                 <BookingDetailsModal
//                     booking={selectedBooking}
//                     onClose={() => setSelectedBooking(null)}
//                 />
//             )}

//             {toast && (
//                 <div className="fixed bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-xs sm:text-sm font-medium px-4 sm:px-5 py-2.5 sm:py-3 rounded-xl shadow-lg flex items-center gap-2 z-50 max-w-[90%]">
//                     <CheckCircle2 size={14} className="text-emerald-400 flex-shrink-0" />
//                     <span className="truncate">{toast}</span>
//                 </div>
//             )}
//         </div>
//     );
// }





import React, { useState, useEffect } from "react";
import {
    Search,
    FileText,
    CheckCircle2,
    Package,
    Truck,
    Clock,
    X,
    Calendar,
    IndianRupee,
    Building2,
    RefreshCw,
    User,
    AlertCircle,
    Check,
    XCircle,
    Loader2,
    Eye,
    CheckCheck,
    PackageCheck,
    ShieldCheck,
    Truck as TruckIcon,
    ChevronDown,
} from "lucide-react";

/* ==========================================================
   Static dummy data — no API / service file involved.
   Replace this array whenever you want to change what shows up.
   ========================================================== */
const INITIAL_BOOKINGS = [
    {
        bookingId: 20431,
        bookingType: "WORK_ORDER",
        bookingStatus: "CREATED",
        userId: 101,
        userName: "Rohan Mehta",
        machineName: "CNC Vertical Milling Machine",
        facilityName: "Precision Works, Pune",
        bookingDate: "2026-07-28",
        startTime: "09:00",
        endTime: "2026-07-28T13:00",
        durationHours: 4,
        hourlyRate: 1800,
        totalAmount: 7200,
        purpose: "Prototype milling for a bracket assembly, tight tolerance required.",
    },
    {
        bookingId: 20432,
        bookingType: "WORK_ORDER",
        bookingStatus: "ACCEPTED",
        userId: 102,
        userName: "Ananya Sharma",
        machineName: "Laser Cutting Machine",
        facilityName: "Metro Fab Hub, Hyderabad",
        bookingDate: "2026-07-26",
        startTime: "11:00",
        endTime: "2026-07-26T15:00",
        durationHours: 4,
        hourlyRate: 2500,
        totalAmount: 10000,
        purpose: "Sheet metal panel cutting for enclosure batch.",
    },
    {
        bookingId: 20433,
        bookingType: "WORK_ORDER",
        bookingStatus: "IN_PROGRESS",
        userId: 103,
        userName: "Karthik Iyer",
        machineName: "Hydraulic Press Brake",
        facilityName: "Precision Works, Pune",
        bookingDate: "2026-07-24",
        startTime: "10:00",
        endTime: "2026-07-24T14:00",
        durationHours: 4,
        hourlyRate: 1200,
        totalAmount: 4800,
        purpose: "Bending operations for chassis frame components.",
    },
    {
        bookingId: 20434,
        bookingType: "WORK_ORDER",
        bookingStatus: "QUALITY_CHECK",
        userId: 104,
        userName: "Priya Nair",
        machineName: "3D Printer — SLS",
        facilityName: "MakerLab, Bengaluru",
        bookingDate: "2026-07-23",
        startTime: "08:00",
        endTime: "2026-07-23T12:00",
        durationHours: 4,
        hourlyRate: 900,
        totalAmount: 3600,
        purpose: "Functional prototype printing for housing design.",
    },
    {
        bookingId: 20435,
        bookingType: "WORK_ORDER",
        bookingStatus: "READY_FOR_DELIVERY",
        userId: 105,
        userName: "Vikram Singh",
        machineName: "TIG Welding Station",
        facilityName: "Metro Fab Hub, Hyderabad",
        bookingDate: "2026-07-21",
        startTime: "13:00",
        endTime: "2026-07-21T17:00",
        durationHours: 4,
        hourlyRate: 700,
        totalAmount: 2800,
        purpose: "Welding for fuel tank bracket, aluminium.",
    },
    {
        bookingId: 20436,
        bookingType: "WORK_ORDER",
        bookingStatus: "DELIVERED",
        userId: 106,
        userName: "Sneha Reddy",
        machineName: "CNC Vertical Milling Machine",
        facilityName: "Precision Works, Pune",
        bookingDate: "2026-07-18",
        startTime: "09:00",
        endTime: "2026-07-18T17:00",
        durationHours: 8,
        hourlyRate: 1800,
        totalAmount: 14400,
        purpose: "Batch milling of 50 aluminium housings.",
    },
    {
        bookingId: 20437,
        bookingType: "WORK_ORDER",
        bookingStatus: "COMPLETED",
        userId: 107,
        userName: "Arjun Rao",
        machineName: "Laser Cutting Machine",
        facilityName: "Metro Fab Hub, Hyderabad",
        bookingDate: "2026-07-15",
        startTime: "10:00",
        endTime: "2026-07-15T14:00",
        durationHours: 4,
        hourlyRate: 2500,
        totalAmount: 10000,
        purpose: "Signage panel cutting, powder-coated steel.",
    },
    {
        bookingId: 20438,
        bookingType: "WORK_ORDER",
        bookingStatus: "CANCELLED",
        userId: 108,
        userName: "Divya Menon",
        machineName: "Hydraulic Press Brake",
        facilityName: "Precision Works, Pune",
        bookingDate: "2026-07-12",
        startTime: "09:00",
        endTime: "2026-07-12T11:00",
        durationHours: 2,
        hourlyRate: 1200,
        totalAmount: 2400,
        purpose: "Cancelled by customer — spec change.",
    },
];

// ---- Custom scrollbar styling ------------------------------------------------
function ScrollbarStyles() {
    return (
        <style>{`
            .custom-scrollbar::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
                background: transparent;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
                background-color: #CBD5E1;
                border-radius: 9999px;
                border: 2px solid transparent;
                background-clip: padding-box;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                background-color: #94A3B8;
            }
            .custom-scrollbar {
                scrollbar-width: thin;
                scrollbar-color: #CBD5E1 transparent;
            }
            @media (max-width: 640px) {
                .mobile-table {
                    display: block;
                }
                .mobile-table thead {
                    display: none;
                }
                .mobile-table tbody {
                    display: block;
                }
                .mobile-table tbody tr {
                    display: block;
                    padding: 16px;
                    margin-bottom: 12px;
                    border: 1px solid #E2E8F0;
                    border-radius: 12px;
                    background: white;
                }
                .mobile-table tbody td {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 6px 0;
                    border: none;
                }
                .mobile-table tbody td::before {
                    content: attr(data-label);
                    font-weight: 600;
                    color: #64748B;
                    font-size: 11px;
                    text-transform: uppercase;
                }
                .mobile-table tbody td:last-child {
                    border-bottom: none;
                }
                .mobile-table tbody td .mobile-label {
                    display: inline;
                }
            }
        `}</style>
    );
}

const currency = (n) => "\u20B9" + n.toLocaleString("en-IN");

const formatDate = (d) => {
    if (!d) return "-";
    const date = new Date(d);
    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

const formatTime = (time) => {
    if (!time) return "-";
    if (time.includes(':')) {
        const [hours, minutes] = time.split(':');
        const h = parseInt(hours);
        const ampm = h >= 12 ? 'PM' : 'AM';
        const h12 = h % 12 || 12;
        return `${h12}:${minutes} ${ampm}`;
    }
    return time;
};

// ---- Status configuration with flow -------------------------------------------
const STATUS_FLOW = {
    CREATED: {
        label: "Created",
        order: 1,
        icon: Clock,
        color: "#F59E0B",
        bg: "#FEF3C7",
        text: "#B45309",
        nextActions: ["ACCEPTED", "CANCELLED"]
    },
    ACCEPTED: {
        label: "Accepted",
        order: 2,
        icon: CheckCircle2,
        color: "#6366F1",
        bg: "#EEF0FF",
        text: "#4338CA",
        nextActions: ["IN_PROGRESS", "CANCELLED"]
    },
    IN_PROGRESS: {
        label: "In Progress",
        order: 3,
        icon: Truck,
        color: "#0EA5E9",
        bg: "#E9F7FE",
        text: "#0369A1",
        nextActions: ["QUALITY_CHECK", "CANCELLED"]
    },
    QUALITY_CHECK: {
        label: "Quality Check",
        order: 4,
        icon: ShieldCheck,
        color: "#8B5CF6",
        bg: "#F3EEFE",
        text: "#6D28D9",
        nextActions: ["READY_FOR_DELIVERY", "CANCELLED"]
    },
    READY_FOR_DELIVERY: {
        label: "Ready for Delivery",
        order: 5,
        icon: PackageCheck,
        color: "#F59E0B",
        bg: "#FEF3C7",
        text: "#B45309",
        nextActions: ["DELIVERED", "CANCELLED"]
    },
    DELIVERED: {
        label: "Delivered",
        order: 6,
        icon: TruckIcon,
        color: "#22C55E",
        bg: "#D1FAE5",
        text: "#065F46",
        nextActions: ["COMPLETED"]
    },
    COMPLETED: {
        label: "Completed",
        order: 7,
        icon: CheckCheck,
        color: "#22C55E",
        bg: "#D1FAE5",
        text: "#065F46",
        nextActions: []
    },
    CANCELLED: {
        label: "Cancelled",
        order: 8,
        icon: XCircle,
        color: "#EF4444",
        bg: "#FEE2E2",
        text: "#991B1B",
        nextActions: []
    },
};

// Get status by key with fallback
const getStatusConfig = (status) => {
    return STATUS_FLOW[status] || {
        label: status || "Unknown",
        order: 99,
        icon: Clock,
        color: "#94A3B8",
        bg: "#F1F5F9",
        text: "#475569",
        nextActions: []
    };
};

// ---- Stat card ---------------------------------------------------------------
function StatCard({ label, value, icon: Icon, accent, onClick, active }) {
    return (
        <div
            onClick={onClick}
            className={`rounded-2xl border ${active ? 'border-indigo-500 ring-2 ring-indigo-200' : 'border-slate-200'} bg-white px-4 py-4 sm:px-6 sm:py-5 flex flex-col gap-2 sm:gap-3 cursor-pointer transition-all hover:shadow-md`}
        >
            <div className="flex items-center justify-between">
                <span className="text-[10px] sm:text-[11px] font-semibold tracking-wider text-slate-400 uppercase">
                    {label}
                </span>
                <div
                    className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: accent + "15" }}
                >
                   <Icon size={14} style={{ color: accent }} />
                </div>
            </div>
            <span className="text-xl sm:text-2xl font-bold text-slate-900">{value}</span>
        </div>
    );
}

// ---- Status Dropdown Component (updates local state only) --------------------
function StatusDropdown({ currentStatus, bookingId, onStatusUpdate }) {
    const [isOpen, setIsOpen] = useState(false);

    const config = getStatusConfig(currentStatus);
    const StatusIcon = config.icon;

    // Get all available statuses
    const allStatuses = ["CREATED", "ACCEPTED", "IN_PROGRESS", "QUALITY_CHECK", "READY_FOR_DELIVERY", "DELIVERED", "COMPLETED", "CANCELLED"];

    // Filter statuses that are allowed from current status
    const availableStatuses = allStatuses.filter(status => {
        if (status === currentStatus) return true;
        return config.nextActions.includes(status);
    });

    const handleStatusChange = (status) => {
        if (status === currentStatus) {
            setIsOpen(false);
            return;
        }
        if (onStatusUpdate) {
            onStatusUpdate(bookingId, status);
        }
        setIsOpen(false);
    };

    return (
        <div className="relative inline-block">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium transition-all hover:shadow-md"
                style={{
                    backgroundColor: config.bg,
                    color: config.text,
                }}
            >
                <StatusIcon size={12} />
                <span>{config.label}</span>
                <ChevronDown size={12} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-slate-200 py-1 z-50 min-w-[160px]">
                    {availableStatuses.map((status) => {
                        const statusConfig = getStatusConfig(status);
                        const StatusIconComp = statusConfig.icon;
                        const isActive = status === currentStatus;

                        return (
                            <button
                                key={status}
                                onClick={() => handleStatusChange(status)}
                                disabled={isActive}
                                className={`w-full px-4 py-2 text-left text-xs font-medium transition-colors flex items-center gap-2 hover:bg-slate-50 ${
                                    isActive ? 'bg-slate-100 cursor-default' : ''
                                }`}
                                style={{
                                    color: isActive ? statusConfig.text : '#475569'
                                }}
                            >
                                <StatusIconComp size={12} style={{ color: statusConfig.color }} />
                                <span>{statusConfig.label}</span>
                                {isActive && (
                                    <Check size={12} className="ml-auto text-emerald-500" />
                                )}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

// ---- Booking Details Modal (View Only) ---------------------------------------
function BookingDetailsModal({ booking, onClose }) {
    if (!booking) return null;

    const currentConfig = getStatusConfig(booking.bookingStatus);
    const StatusIcon = currentConfig.icon || Clock;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
            <div
                className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px]"
                onClick={onClose}
            />
            <div className="relative w-full max-w-lg rounded-2xl bg-white shadow-xl border border-slate-200 overflow-hidden max-h-[95vh] flex flex-col">
                <div className="flex items-start justify-between px-4 sm:px-6 pt-4 sm:pt-6 pb-3 sm:pb-4 border-b border-slate-100 flex-shrink-0">
                    <div className="min-w-0">
                        <h2 className="text-base sm:text-lg font-bold text-slate-900 truncate">Order Details</h2>
                        <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
                            Order #{booking.bookingId}
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-slate-600 rounded-lg p-1 flex-shrink-0"
                    >
                        <X size={18} />
                    </button>
                </div>

                <div className="px-4 sm:px-6 py-4 sm:py-5 space-y-4 overflow-y-auto flex-1 custom-scrollbar">
                    {/* Status Timeline */}
                    <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                        <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">Order Progress</h3>
                        <StatusTimeline currentStatus={booking.bookingStatus} />
                    </div>

                    <div className="rounded-xl bg-slate-50 border border-slate-100 p-3 sm:p-4 space-y-2 sm:space-y-3">
                        <div className="flex items-center justify-between text-xs sm:text-sm">
                            <span className="text-slate-500 flex items-center gap-1.5">
                                <User size={14} /> Customer
                            </span>
                            <span className="font-medium text-slate-800 text-right truncate ml-2">{booking.userName}</span>
                        </div>
                        <div className="flex items-center justify-between text-xs sm:text-sm">
                            <span className="text-slate-500 flex items-center gap-1.5">
                                <Building2 size={14} /> Facility
                            </span>
                            <span className="font-medium text-slate-800 text-right truncate ml-2">{booking.facilityName}</span>
                        </div>
                        <div className="flex items-center justify-between text-xs sm:text-sm">
                            <span className="text-slate-500 flex items-center gap-1.5">
                                <Package size={14} /> Machine
                            </span>
                            <span className="font-medium text-slate-800 text-right truncate ml-2">{booking.machineName}</span>
                        </div>
                        <div className="flex items-center justify-between text-xs sm:text-sm">
                            <span className="text-slate-500 flex items-center gap-1.5">
                                <Calendar size={14} /> Date
                            </span>
                            <span className="font-medium text-slate-800">{formatDate(booking.bookingDate)}</span>
                        </div>
                        <div className="flex items-center justify-between text-xs sm:text-sm">
                            <span className="text-slate-500 flex items-center gap-1.5">
                                <Clock size={14} /> Time
                            </span>
                            <span className="font-medium text-slate-800 text-right">
                                {formatTime(booking.startTime)} - {formatTime(booking.endTime?.split('T')[1] || booking.endTime)}
                            </span>
                        </div>
                        <div className="flex items-center justify-between text-xs sm:text-sm">
                            <span className="text-slate-500 flex items-center gap-1.5">
                                <Clock size={14} /> Duration
                            </span>
                            <span className="font-medium text-slate-800">{booking.durationHours} hours</span>
                        </div>
                        <div className="flex items-center justify-between text-xs sm:text-sm">
                            <span className="text-slate-500 flex items-center gap-1.5">
                                <IndianRupee size={14} /> Total Amount
                            </span>
                            <span className="font-semibold text-slate-900">
                                {currency(booking.totalAmount)}
                            </span>
                        </div>
                    </div>

                    <div>
                        <div className="text-xs sm:text-sm font-medium text-slate-700 block mb-1.5">Purpose</div>
                        <div className="rounded-xl border border-slate-100 px-3 py-2 sm:px-3.5 sm:py-2.5 text-xs sm:text-sm text-slate-600 bg-slate-50 break-words">
                            {booking.purpose || "No purpose specified"}
                        </div>
                    </div>

                    {/* Current Status Display */}
                    <div>
                        <div className="text-xs sm:text-sm font-medium text-slate-700 block mb-1.5">Current Status</div>
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium"
                            style={{
                                backgroundColor: currentConfig.bg,
                                color: currentConfig.text
                            }}
                        >
                            <StatusIcon size={16} />
                            {currentConfig.label}
                        </div>
                    </div>
                </div>

                <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-slate-100 flex items-center justify-end bg-slate-50 flex-shrink-0">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-xl text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

// ---- Status Timeline Component -----------------------------------------------
function StatusTimeline({ currentStatus }) {
    const statuses = ["CREATED", "ACCEPTED", "IN_PROGRESS", "QUALITY_CHECK", "READY_FOR_DELIVERY", "DELIVERED", "COMPLETED"];
    const currentIndex = statuses.indexOf(currentStatus);
    const isCancelled = currentStatus === "CANCELLED";

    if (isCancelled) {
        return (
            <div className="flex items-center gap-2 p-3 bg-red-50 rounded-xl border border-red-200">
                <XCircle size={20} className="text-red-500 flex-shrink-0" />
                <span className="text-sm font-medium text-red-700">Order has been cancelled</span>
            </div>
        );
    }

    return (
        <div className="relative">
            <div className="flex flex-wrap items-center gap-1 sm:gap-2">
                {statuses.map((status, index) => {
                    const config = getStatusConfig(status);
                    const isCompleted = index <= currentIndex;
                    const isCurrent = index === currentIndex;
                    const StatusIcon = config.icon;

                    return (
                        <React.Fragment key={status}>
                            <div className="flex items-center gap-1 sm:gap-2">
                                <div
                                    className={`flex items-center gap-1 sm:gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-[10px] sm:text-xs font-medium transition-all ${
                                        isCompleted
                                            ? 'bg-emerald-100 text-emerald-700'
                                            : 'bg-slate-100 text-slate-400'
                                    } ${isCurrent ? 'ring-2 ring-emerald-400 shadow-sm' : ''}`}
                                >
                                    <StatusIcon
                                        size={12}
                                        className={isCompleted ? 'text-emerald-600' : 'text-slate-400'}
                                    />
                                    <span className="whitespace-nowrap">{config.label}</span>
                                    {isCurrent && (
                                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse ml-0.5" />
                                    )}
                                </div>
                                {index < statuses.length - 1 && (
                                    <div className={`w-4 sm:w-6 h-0.5 ${index < currentIndex ? 'bg-emerald-400' : 'bg-slate-200'}`} />
                                )}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
}

// ---- Mobile Order Card --------------------------------------------------------
function MobileOrderCard({ booking, onViewDetails, onStatusUpdate }) {
    const cfg = getStatusConfig(booking.bookingStatus);
    const StatusIcon = cfg.icon;

    return (
        <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm">
            <div className="flex items-start justify-between mb-3">
                <div>
                    <div className="font-semibold text-slate-900">#{booking.bookingId}</div>
                    <div className="text-xs text-slate-400">{booking.bookingType || "WORK_ORDER"}</div>
                </div>
                <div className="flex items-center gap-2">
                    <span
                        className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-medium"
                        style={{ backgroundColor: cfg.bg, color: cfg.text }}
                    >
                        <StatusIcon size={10} />
                        {cfg.label}
                    </span>
                </div>
            </div>

            <div className="space-y-2 text-sm">
                <div className="flex items-start gap-2">
                    <User size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">{booking.userName}</span>
                </div>
                <div className="flex items-start gap-2">
                    <Package size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">{booking.machineName}</span>
                </div>
                <div className="flex items-start gap-2">
                    <Building2 size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700 text-xs">{booking.facilityName}</span>
                </div>
                <div className="flex items-start gap-2">
                    <IndianRupee size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
                    <span className="font-semibold text-slate-900">{currency(booking.totalAmount)}</span>
                </div>
                <div className="flex items-start gap-2">
                    <Calendar size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">{formatDate(booking.bookingDate)}</span>
                </div>
            </div>

            <div className="flex items-center gap-2 mt-3">
                {/* Status Dropdown */}
                <div className="flex-1">
                    <StatusDropdown
                        currentStatus={booking.bookingStatus}
                        bookingId={booking.bookingId}
                        onStatusUpdate={onStatusUpdate}
                    />
                </div>

                <button
                    onClick={() => onViewDetails(booking)}
                    className="px-3 py-2 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 rounded-xl text-sm font-medium flex items-center gap-1.5 transition-colors"
                >
                    <Eye size={14} /> View
                </button>
            </div>
        </div>
    );
}

// ---- Main page ----------------------------------------------------------------
export default function OrdersPage() {
    // Static local state — seeded from dummy data, no fetch/service call.
    const [bookings, setBookings] = useState(INITIAL_BOOKINGS);
    const [query, setQuery] = useState("");
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [toast, setToast] = useState(null);
    const [activeFilter, setActiveFilter] = useState("all");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 640);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const showToast = (text) => {
        setToast(text);
        setTimeout(() => setToast(null), 3000);
    };

    const handleRefresh = () => {
        // No backend call — just resets back to the seed data
        setBookings(INITIAL_BOOKINGS);
        showToast("Orders refreshed");
    };

    const handleStatusUpdate = (bookingId, newStatus) => {
        setBookings(prev =>
            prev.map(b =>
                b.bookingId === bookingId
                    ? { ...b, bookingStatus: newStatus }
                    : b
            )
        );
        showToast(`Order #${bookingId} status updated to ${getStatusConfig(newStatus).label}`);
    };

    const matchesQuery = (b) => {
        const q = query.toLowerCase();
        return (
            b.machineName?.toLowerCase().includes(q) ||
            b.facilityName?.toLowerCase().includes(q) ||
            b.userName?.toLowerCase().includes(q) ||
            b.bookingId?.toString().includes(q)
        );
    };

    const getFilteredBookings = () => {
        let filtered = bookings.filter(matchesQuery);
        if (activeFilter !== "all") {
            filtered = filtered.filter(b => b.bookingStatus === activeFilter.toUpperCase());
        }
        return filtered;
    };

    const filteredBookings = getFilteredBookings();

    const counts = {
        total: bookings.length,
        created: bookings.filter((b) => b.bookingStatus === "CREATED").length,
        accepted: bookings.filter((b) => b.bookingStatus === "ACCEPTED").length,
        in_progress: bookings.filter((b) => b.bookingStatus === "IN_PROGRESS").length,
        quality_check: bookings.filter((b) => b.bookingStatus === "QUALITY_CHECK").length,
        ready_for_delivery: bookings.filter((b) => b.bookingStatus === "READY_FOR_DELIVERY").length,
        delivered: bookings.filter((b) => b.bookingStatus === "DELIVERED").length,
        completed: bookings.filter((b) => b.bookingStatus === "COMPLETED").length,
        cancelled: bookings.filter((b) => b.bookingStatus === "CANCELLED").length,
    };

    return (
        <div className="min-h-screen bg-slate-50 py-4 sm:py-8 px-3 sm:px-6 font-sans overflow-y-auto custom-scrollbar">
            <ScrollbarStyles />
            <div className="max-w-7xl mx-auto space-y-4 sm:space-y-6">
                {/* Header */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
                    <div>
                        <h1 className="text-lg sm:text-xl font-bold text-slate-900">Work Orders</h1>
                        <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
                            Manage all work orders from customers
                        </p>
                    </div>
                    <button
                        onClick={handleRefresh}
                        className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs sm:text-sm font-medium transition-colors hover:shadow-lg w-full sm:w-auto justify-center"
                    >
                        <RefreshCw size={14} /> Refresh
                    </button>
                </div>

                {/* Stat cards */}
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-4">

    <StatCard
        label="Created"
        value={counts.created}
        icon={Clock}
        accent="#F59E0B"
        onClick={() => setActiveFilter("created")}
        active={activeFilter === "created"}
    />
    <StatCard
        label="Accepted"
        value={counts.accepted}
        icon={CheckCircle2}
        accent="#6366F1"
        onClick={() => setActiveFilter("accepted")}
        active={activeFilter === "accepted"}
    />
    <StatCard
        label="In Progress"
        value={counts.in_progress + counts.quality_check}
        icon={Truck}
        accent="#0EA5E9"
        onClick={() => setActiveFilter("in_progress")}
        active={activeFilter === "in_progress" || activeFilter === "quality_check"}
    />
    <StatCard
        label="Completed"
        value={counts.completed + counts.delivered}
        icon={CheckCircle2}
        accent="#22C55E"
        onClick={() => setActiveFilter("completed")}
        active={activeFilter === "completed" || activeFilter === "delivered"}
    />
    <StatCard
        label="Cancelled"
        value={counts.cancelled}
        icon={XCircle}
        accent="#EF4444"
        onClick={() => setActiveFilter("cancelled")}
        active={activeFilter === "cancelled"}
    />
</div>

                {/* Search and Filters */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-stretch sm:items-center justify-between">
                    <div className="relative flex-1 max-w-full sm:max-w-md">
                        <Search
                            size={16}
                            className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-slate-400"
                        />
                        <input
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Search by machine, facility, user..."
                            className="w-full rounded-full border border-slate-200 bg-white pl-9 sm:pl-10 pr-4 py-2 text-xs sm:text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
                        />
                    </div>

                    {/* Mobile Filter Dropdown */}
                    <div className="sm:hidden flex gap-2">
                        <select
                            value={activeFilter}
                            onChange={(e) => setActiveFilter(e.target.value)}
                            className="flex-1 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                        >
                            <option value="all">All ({counts.total})</option>
                            <option value="created">Created ({counts.created})</option>
                            <option value="accepted">Accepted ({counts.accepted})</option>
                            <option value="in_progress">In Progress ({counts.in_progress + counts.quality_check})</option>
                            <option value="completed">Completed ({counts.completed + counts.delivered})</option>
                            <option value="cancelled">Cancelled ({counts.cancelled})</option>
                        </select>
                    </div>

                    {/* Desktop Filter Tabs */}
                    <div className="hidden sm:inline-flex items-center gap-1 rounded-full bg-slate-100 p-1 flex-wrap">
                        <button
                            onClick={() => setActiveFilter("all")}
                            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "all"
                                    ? "bg-white text-indigo-700 shadow-sm"
                                    : "text-slate-500 hover:text-slate-700"
                                }`}
                        >
                            All ({counts.total})
                        </button>
                        <button
                            onClick={() => setActiveFilter("created")}
                            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "created"
                                    ? "bg-white text-indigo-700 shadow-sm"
                                    : "text-slate-500 hover:text-slate-700"
                                }`}
                        >
                            Created ({counts.created})
                        </button>
                        <button
                            onClick={() => setActiveFilter("accepted")}
                            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "accepted"
                                    ? "bg-white text-indigo-700 shadow-sm"
                                    : "text-slate-500 hover:text-slate-700"
                                }`}
                        >
                            Accepted ({counts.accepted})
                        </button>
                        <button
                            onClick={() => setActiveFilter("in_progress")}
                            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "in_progress" || activeFilter === "quality_check"
                                    ? "bg-white text-indigo-700 shadow-sm"
                                    : "text-slate-500 hover:text-slate-700"
                                }`}
                        >
                            In Progress ({counts.in_progress + counts.quality_check})
                        </button>
                        <button
                            onClick={() => setActiveFilter("completed")}
                            className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors whitespace-nowrap ${activeFilter === "completed" || activeFilter === "delivered"
                                    ? "bg-white text-indigo-700 shadow-sm"
                                    : "text-slate-500 hover:text-slate-700"
                                }`}
                        >
                            Completed ({counts.completed + counts.delivered})
                        </button>
                    </div>
                </div>

                {/* Bookings table / cards */}
                <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm">
                    <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-slate-100">
                        <h2 className="font-bold text-slate-900 text-sm sm:text-[15px]">
                            {activeFilter === "all" ? "All Work Orders" : `${activeFilter.replace('_', ' ').toUpperCase()} Orders`}
                        </h2>
                        <p className="text-xs text-slate-400 mt-0.5">
                            {activeFilter === "all"
                                ? "View all work orders and their status"
                                : `View all ${activeFilter.replace('_', ' ')} orders`}
                        </p>
                    </div>

                    {/* Mobile View - Cards */}
                    {isMobile ? (
                        <div className="p-3 space-y-3">
                            {filteredBookings.map((b) => (
                                <MobileOrderCard
                                    key={b.bookingId}
                                    booking={b}
                                    onViewDetails={setSelectedBooking}
                                    onStatusUpdate={handleStatusUpdate}
                                />
                            ))}
                            {filteredBookings.length === 0 && (
                                <div className="text-center text-slate-400 text-sm py-8">
                                    {query ? "No orders match your search." : "No orders found."}
                                </div>
                            )}
                        </div>
                    ) : (
                        /* Desktop View - Table */
                        <div className="overflow-auto max-h-[480px] custom-scrollbar">
                            <table className="w-full text-sm">
                                <thead className="sticky top-0 z-10 bg-white">
                                    <tr className="text-left text-[11px] font-semibold tracking-wider text-slate-400 uppercase border-b border-slate-100">
                                        <th className="px-6 py-3 font-semibold">Order</th>
                                        <th className="px-4 py-3 font-semibold">Customer</th>
                                        <th className="px-4 py-3 font-semibold">Machine / Facility</th>
                                        <th className="px-4 py-3 font-semibold">Date & Time</th>
                                        <th className="px-4 py-3 font-semibold text-right">Amount</th>
                                        <th className="px-4 py-3 font-semibold">Status</th>
                                        <th className="px-6 py-3 font-semibold text-right">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredBookings.map((b) => {
                                        const cfg = getStatusConfig(b.bookingStatus);
                                        const StatusIcon = cfg.icon;
                                        return (
                                            <tr
                                                key={b.bookingId}
                                                className="border-b border-slate-50 last:border-0 hover:bg-slate-50/60 transition-colors"
                                            >
                                                <td className="px-6 py-4">
                                                    <div className="font-semibold text-slate-900">
                                                        #{b.bookingId}
                                                    </div>
                                                    <div className="text-xs text-slate-400 mt-0.5">
                                                        {b.bookingType || "WORK_ORDER"}
                                                    </div>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <div className="font-medium text-slate-700">{b.userName}</div>
                                                    <div className="text-xs text-slate-400 mt-0.5">
                                                        User #{b.userId}
                                                    </div>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <div className="font-medium text-slate-700">{b.machineName}</div>
                                                    <div className="text-xs text-slate-400 mt-0.5 flex items-center gap-1">
                                                        <Building2 size={11} />
                                                        {b.facilityName}
                                                    </div>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <div className="text-slate-700">{formatDate(b.bookingDate)}</div>
                                                    <div className="text-xs text-slate-400 mt-0.5">
                                                        {formatTime(b.startTime)} - {formatTime(b.endTime?.split('T')[1] || b.endTime)}
                                                    </div>
                                                </td>
                                                <td className="px-4 py-4 text-right">
                                                    <div className="font-semibold text-slate-900">
                                                        {currency(b.totalAmount)}
                                                    </div>
                                                    <div className="text-xs text-slate-400 mt-0.5">
                                                        {b.durationHours} hrs @ {currency(b.hourlyRate)}/hr
                                                    </div>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <StatusDropdown
                                                        currentStatus={b.bookingStatus}
                                                        bookingId={b.bookingId}
                                                        onStatusUpdate={handleStatusUpdate}
                                                    />
                                                </td>
                                                <td className="px-6 py-4 text-right">
                                                    <button
                                                        onClick={() => setSelectedBooking(b)}
                                                        className="inline-flex items-center gap-1.5 text-indigo-600 hover:text-indigo-800 text-sm font-medium px-3 py-2 rounded-xl border border-indigo-100 hover:bg-indigo-50 transition-colors"
                                                    >
                                                        <Eye size={14} /> View Details
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    {filteredBookings.length === 0 && (
                                        <tr>
                                            <td colSpan={7} className="px-6 py-10 text-center text-slate-400 text-sm">
                                                {query ? "No orders match your search." : "No orders found."}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {selectedBooking && (
                <BookingDetailsModal
                    booking={selectedBooking}
                    onClose={() => setSelectedBooking(null)}
                />
            )}

            {toast && (
                <div className="fixed bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-xs sm:text-sm font-medium px-4 sm:px-5 py-2.5 sm:py-3 rounded-xl shadow-lg flex items-center gap-2 z-50 max-w-[90%]">
                    <CheckCircle2 size={14} className="text-emerald-400 flex-shrink-0" />
                    <span className="truncate">{toast}</span>
                </div>
            )}
        </div>
    );
}